import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { SAMPLE_SONGS, CATEGORIES } from '../../mock';
import { API, fileUrl } from '../../api';
import AudioPlayer from '../AudioPlayer';
import { Share2 } from 'lucide-react';

function Ticker() {
  const row = [...CATEGORIES, ...CATEGORIES];
  return (
    <div className="relative overflow-hidden py-5 border-y hairline mb-20">
      <div className="flex gap-10 whitespace-nowrap animate-[ticker_38s_linear_infinite]" style={{ width: 'max-content' }}>
        {row.map((c, i) => (
          <span key={i} className="font-display text-2xl text-cream/25 italic">{c}</span>
        ))}
      </div>
      <style>{`@keyframes ticker{from{transform:translateX(0)}to{transform:translateX(-50%)}}`}</style>
    </div>
  );
}

export default function SongsSection() {
  const [songs, setSongs] = useState(SAMPLE_SONGS);
  useEffect(() => { API.songs().then((s) => s?.length && setSongs(s)).catch(() => {}); }, []);
  const hasReal = songs.some((s) => s.share_code);
  return (
    <section id="listen" className="relative py-28 bg-ink">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <Ticker />
        <div className="reveal max-w-2xl mb-14">
          <p className="eyebrow mb-4">Listen</p>
          <h2 className="font-display text-5xl md:text-6xl text-cream leading-[0.95]">Brands that became <span className="italic text-gold-grad">a Song.</span></h2>
          <p className="mt-5 text-cream/65 text-lg">Every business here has a song nobody else has. Press play.</p>
        </div>
        <div className="grid md:grid-cols-2 gap-5">
          {songs.map((s, i) => (
            <div key={s.id} data-testid={`song-card-${s.id}`} className="reveal panel rounded-2xl p-5 hover:border-gold/40 transition-all duration-500 group" style={{ transitionDelay: `${i * 70}ms` }}>
              <div className="flex items-center gap-4 mb-5">
                <img src={fileUrl(s.cover)} alt={s.business} className="w-16 h-16 rounded-xl object-cover ring-1 ring-gold/20" />
                <div className="min-w-0 flex-1">
                  <p className="eyebrow text-[10px] mb-1">{s.category}</p>
                  <h3 className="font-display text-2xl text-cream leading-tight truncate">{s.title}</h3>
                  <p className="text-sm text-cream/55 truncate">{s.business} &middot; {s.genre}</p>
                </div>
                {s.share_code && <Link to={`/song/${s.share_code}`} data-testid={`song-share-link-${s.id}`} className="shrink-0 grid place-items-center w-9 h-9 rounded-full border hairline text-cream/60 hover:text-gold hover:border-gold/50 transition-colors" title="Open song page"><Share2 size={14} /></Link>}
              </div>
              <AudioPlayer id={s.id} src={s.audio} previewLabel={s.duration || undefined} />
            </div>
          ))}
        </div>
        {!hasReal && <p className="text-xs text-cream/35 mt-10 max-w-2xl">Prototype: businesses, people and songs are samples. The audio is placeholder music; Perry&rsquo;s real songs go here.</p>}
      </div>
    </section>
  );
}
